import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../atoms/date-picker/date-picker.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-date-of-birth',
  imports: [DatePickerComponent, ReactiveFormsModule, TranslateModule, ImmomioFormFieldComponent],
  templateUrl: './user-profile-edit-date-of-birth.component.html',
  styleUrl: './user-profile-edit-date-of-birth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class UserProfileEditDateOfBirthComponent {}
